import { AskResponse } from "../../api";
import { Citation_Parsed, AISearchRAGCitation_Parsed, WebSearchCitation_Parsed, isAISearchRAGCitation, isWebSearchCitation, isAISearchRAGCitationParsed } from "../../api/citations";
import { getDownloadURL } from "../../api";

type ParsedAnswer = {
    citations: Citation_Parsed[];
    markdownFormatText: string;
};

function getCitationPattern(index: number) {
  return [
    // doc+数字のパターン
    `[doc${index}]`,
    `【doc${index}】`,

    // 文書+数字のパターン
    `[文書${index}]`,
    `【文書${index}】`,

    // 数字のみのパターン
    `[${index}]`,
    `【${index}】`,
  ]
}

export function parseAnswer(answer: AskResponse): ParsedAnswer {
    let answerText = answer.answer;

    const filteredCitations = [] as Citation_Parsed[];

    // 引用は1から
    let citationReindex = 1;
    const partCount: Map<string, Map<string, number>> = new Map()
    for (const [index, citation] of answer.citations.entries()) {
      const patterns = getCitationPattern(index)
      const cited = patterns.some(v => answerText.includes(v))
      if (!cited) continue
      
      // テキスト中の文字列置換
      patterns.forEach(v => answerText = answerText.replaceAll(v, ` ^${citationReindex}^ `))

      // AISearchチャンクからの引用だった場合
      if (isAISearchRAGCitation(citation)) {
        const url = getDownloadURL(Number(citation.rag_index), String(citation.filepath))
        if (!partCount.has(citation.rag_index)) {
          partCount.set(citation.rag_index, new Map())
        }
        if (!partCount.get(citation.rag_index)?.has(citation.filepath)) {
          partCount.get(citation.rag_index)?.set(citation.filepath, 0)
        }
        partCount.get(citation.rag_index)?.set(citation.filepath, partCount.get(citation.rag_index)?.get(citation.filepath) as number + 1)
        const part = partCount.get(citation.rag_index)?.get(citation.filepath) as number
        const parsed: AISearchRAGCitation_Parsed = {
          ...citation,
          title: `${citation.filepath}をダウンロード`,
          url: url,
          part: part,
        }
        filteredCitations.push(parsed);
      }
      else if (isWebSearchCitation(citation)) {
        const parsed: WebSearchCitation_Parsed = {
          ...citation
        }
        filteredCitations.push(parsed);
      }

      ++citationReindex
    }

    // partが1つしかない場合、そもそもpart分けされていないので削除しておく
    for (const citation of filteredCitations) {
      if (isAISearchRAGCitationParsed(citation)) {
        const part = partCount.get(citation.rag_index)?.get(citation.filepath) as number
        if (part === 1) {
          citation.part = undefined
        }
      }
    }

    return {
        citations: filteredCitations,
        markdownFormatText: answerText,
    };
}
